import {MechanicLargestArmyState, MechanicDevelopmentCardsState} from '@colonist/game-states'
import {UIGamePlayerInformationLargestArmyController} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationLargestArmyController'
import {UIMGamePlayerInformationLargestArmyView} from './UIMGamePlayerInformationLargestArmyView'
import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {UIGamePlayerInformationLargestArmyView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationLargestArmyView'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums

/**
 * @deprecated UIMGamePlayerInformationLargestArmyController will be removed once Pixi.js Mobile Player Information view is removed. Please use UIGamePlayerInformationLargestArmyController.
 */
export class UIMGamePlayerInformationLargestArmyController extends UIGamePlayerInformationLargestArmyController {
    private playerInformationLargestArmyViews: UIGamePlayerInformationLargestArmyView[]

    constructor(uiGameManager: UIGameManager, largestArmyState: MechanicLargestArmyState, developmentCardsState: MechanicDevelopmentCardsState | undefined) {
        super(uiGameManager, largestArmyState, developmentCardsState)

        this.playerInformationLargestArmyViews = []
        this.initPlayerInformationLargestArmyViews()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        super.onEvent(data, eventType)
        switch(eventType) {
            case UIGameEventEnums.CanvasResized: this.initPlayerInformationLargestArmyViews(); break
            default: break
        }
    }

    private initPlayerInformationLargestArmyViews() {
        this.playerInformationLargestArmyViews.forEach((view) => view.destroy())
        this.playerInformationLargestArmyViews = []

        for(const playerState of this.uiGameManager.gameState.players) {
            const newPlayerInformationLargestArmyView = new UIMGamePlayerInformationLargestArmyView(this.uiGameManager, playerState)
            this.playerInformationLargestArmyViews.push(newPlayerInformationLargestArmyView)
        }
    }
}
